import { useParams, Link } from "react-router-dom";
import { categories, videos } from "@/mocks/siteData";
import { siteConfig } from "@/mocks/siteData";
import SEOMeta from "@/components/feature/SEOMeta";
import { WebPageSchema } from "@/components/feature/SchemaOrg";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import VideoCard from "@/components/feature/VideoCard";
import Breadcrumb from "@/components/feature/Breadcrumb";

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const category = categories.find((c) => c.slug === slug);

  if (!category) {
    return (
      <div className="min-h-screen bg-background-50 pt-16">
        <Navbar />
        <div className="flex flex-col items-center justify-center py-20">
          <h1 className="text-2xl font-bold text-foreground-900">分类不存在</h1>
          <Link to="/" className="text-primary-500 mt-4 hover:underline cursor-pointer">
            返回首页
          </Link>
        </div>
        <Footer />
      </div>
    );
  }

  const categoryVideos = videos.filter((v) => v.category === slug);
  const pageTitle = `${category.name} - 91视频国产${category.name}在线观看`;
  const pageDescription = `${category.description}。91视频网站为您提供高清流畅的国产${category.name}免费在线观看服务，每日更新。`;
  const pageUrl = `${siteConfig.url}/category/${slug}`;

  return (
    <>
      <SEOMeta
        title={pageTitle}
        description={pageDescription}
        keywords={`91国产${category.name},91${category.name}在线观看,91视频${category.name},国产${category.name}免费,91${category.name}全集`}
        canonicalUrl={pageUrl}
        ogImage={siteConfig.ogImage}
      />
      <WebPageSchema
        title={pageTitle}
        description={pageDescription}
        url={pageUrl}
        breadcrumbItems={[
          { name: "首页", item: siteConfig.url },
          { name: category.name, item: pageUrl },
        ]}
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main className="pt-20 pb-10">
          <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
            <Breadcrumb
              items={[
                { label: "首页", href: "/" },
                { label: category.name },
              ]}
            />

            <div className="mt-6 mb-8">
              <div className="flex items-center gap-4">
                <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-xl bg-primary-100 text-primary-500">
                  <i className={`${category.icon} text-2xl md:text-3xl`}></i>
                </div>
                <div>
                  <h1 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
                    国产{category.name}
                  </h1>
                  <p className="text-sm text-foreground-600 mt-1">{category.description}</p>
                </div>
              </div>
            </div>

            <div className="flex flex-wrap gap-2 mb-8">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className={`px-4 py-2 rounded-full text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                    cat.slug === slug
                      ? "bg-primary-500 text-white"
                      : "bg-background-100 text-foreground-700 hover:bg-background-200"
                  }`}
                >
                  {cat.name}
                </Link>
              ))}
            </div>

            {categoryVideos.length > 0 ? (
              <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-3 md:gap-4">
                {categoryVideos.map((video) => (
                  <VideoCard key={video.id} {...video} />
                ))}
              </div>
            ) : (
              <div className="text-center py-20">
                <p className="text-foreground-500">该分类暂无内容，敬请期待</p>
              </div>
            )}
          </div>
        </main>

        <Footer />
      </div>
    </>
  );
}